import {
  ContentBlocks_Position,
  ContentBlocks_CTA as CTAType,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/content_blocks.types';
import {
  ContentBlockCTA,
  RowSection,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc from 'styled-components';
import {useContentBlockPromotionTracking} from '../helpers/useContentBlockPromotionTracking';
import {useContentBlockPromotionTrackingImpression} from '../helpers/useContentBlockPromotionTrackingImpression';
import {horizontalPositionMap, styleMap} from '../transforms';

interface CTAInterface {
  content: CTAType;
  blockId?: number;
  testId?: string;
  className?: string;
  onClickCTA?: (
    promotionName: string,
    path: {url: string; external: boolean},
  ) => void;
}

export const CTA: React.FC<CTAInterface> = ({
  content,
  blockId,
  testId = 'customPageCTA',
  className,
  onClickCTA,
}) => {
  const promotionTrackingClick = useContentBlockPromotionTracking();
  const {elementRef: placementRef} =
    useContentBlockPromotionTrackingImpression<HTMLDivElement>({
      contentBlockSource: 'cta',
      locationBlockType: 'cta',
      promotionId: `${blockId ?? ''}`,
      blockId,
      promotionName: content.text.text,
      path: content.link,
    });

  if (content.text.text === '') {
    return null;
  }

  const defaultCTAClick = (
    promotionName: string,
    path: {url: string; external: boolean},
  ) => {
    promotionTrackingClick({
      contentBlockSource: 'cta',
      locationBlockType: 'cta',
      actionType: 'click',
      promotionId: `${blockId ?? ''}`,
      blockId,
      promotionName,
      path,
    });
  };

  const handleCTAClick = onClickCTA || defaultCTAClick;

  return (
    <BlockWrapper
      $backgroundColor={content.backgroundColor}
      centerContent
      data-content-block={blockId}
      ref={placementRef}
    >
      <ContentWrapper position={content.position}>
        <ContentBlockCTA
          text={{
            text: content.text.text,
            style: styleMap[content.text.style],
            textColor: content.text.color,
          }}
          link={content.link}
          testId={testId}
          className={className}
          onClick={() => handleCTAClick(content.text.text, content.link)}
        />
      </ContentWrapper>
    </BlockWrapper>
  );
};

const BlockWrapper = linariaStyled(RowSection)<{
  $backgroundColor?: string;
}>`
  background-color: ${({$backgroundColor}) => $backgroundColor ?? ''};
  padding: 1.5rem 0 1.5rem 0;

  ${tabletAndUpLinaria('padding: 1.5rem 0 3rem 0;')};
  `;

const ContentWrapper = sc.div<{position?: ContentBlocks_Position}>`
  display: flex;
  flex-basis: 100%;
  max-width: 1440px;
  padding: 0 1rem;
  justify-content: ${({position}) =>
    position ? horizontalPositionMap[position] : 'center'};
`;
